<template>
    <div>

        <div @click.stop="open = true">
            <slot name="trigger">
                <button class="outline-none cursor-pointer"><icon name="help-circle"/></button>
            </slot>
        </div>

        <div v-if="open" @click="open = false" class="Modal__overlay">

            <div class="Modal__container" v-if="open" role="dialog">
                <div class="content">
                    <div v-if="content" v-html="content"></div>
                    <slot v-else>void</slot>
                </div>
                <button class="btn mt-8" @click.stop="open = false">Zavřít</button>
            </div>

            <button class="Modal__close" @click.stop="open = false">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>

        </div>

    </div>
</template>

<script>
export default {

    props: [
        'content'
    ],

    data() {
        return {
            open: false
        }
    }
}
</script>

<style lang="scss">
    .Modal {
        &__overlay {
            position: fixed;
            left: 0;
            top:0;
            right: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 20;
            background: rgba(#2d3747, .5);
        }
        &__container {
            width: 550px;
            max-width: 90vw;
            max-height: 90vh;
            padding: 2rem;
            overflow-y: scroll;
            border-radius: .25rem;
            background: #fff;
            color: var(--base-color);
        }
        &__close {
            position: absolute;
            right: .5rem;
            top: .5rem;
            padding: 0;
            background: transparent;
            border: none;
            cursor: pointer;
            &:focus {
                outline: none;
            }
            svg {
                fill: none;
                stroke: #fff;
            }
        }
    }
</style>
